export function HADao(XRAY_RESOURCE, XRayUIDaoFactory) {
	return XRayUIDaoFactory()
		.setPath(XRAY_RESOURCE.HA + '/:param')
		.setCustomActions({
			'getNodes': {
				method: 'GET',
				params: {param: 'nodes'},
				isArray:true
			},
			'delete': {
				method: 'DELETE',
				params: {param: 'nodes'},
				isArray:true
			}
		})
		.getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/ha_dao.js